import '../Assets/css/servicios.css';
import busIcon from "../Assets/icon/IconServicios/IconTravel.png";


export const Servicios = () => {
    const services = [
        { icon: busIcon, title: "Giras de estudios", description: "Brindamos experiencias educativas únicas con traslados seguros y cómodos para estudiantes." },
        { icon: busIcon, title: "Viajes de empresas", description: "Soluciones de transporte exclusivas y de alto estándar para eventos corporativos, garantizando comodidad y puntualidad." },
        { icon: busIcon, title: "Campamentos scout", description: "Facilitamos la logística de campamentos con traslados seguros, garantizando la seguridad de los pasajeros." },
        { icon: busIcon, title: "Traslados de colegios", description: "Ofrecemos servicios integrales para colegios, asegurando un transporte eficiente y seguro para los estudiantes." },
        { icon: busIcon, title: "Traslados corporativos", description: "Ofrecemos traslados exclusivos para eventos empresariales, garantizando comodidad y eficiencia para su equipo." },
        { icon: busIcon, title: "Agencias de turismo", description: "Diseñamos experiencias únicas, proporcionando transporte seguro y cómodo para grupos de turistas y agencias." },
        { icon: busIcon, title: "Eventos especiales", description: "Desde conciertos hasta conferencias, brindamos soluciones de transporte personalizadas para eventos." },
        { icon: busIcon, title: "Pick-Up / Drop-Off Aeropuerto AMB", description: "Realizamos traslados desde y hacia el aeropuerto de Santiago para grupos." }
    ];



    return (
        <div className="services" id="servicios">
            <h1>Servicios</h1>
            <div className="services-container">
                {services.map((service, index) => (
                    <div key={index} className="service-card">
                        <img src={service.icon} alt={service.title}/>
                        <h2 style={{textAlign:'center',fontWeight:'600'}}>{service.title}</h2>
                        <p>{service.description}</p>
                    </div>
                ))}
            </div>
        </div>

    );
}